// extracted by mini-css-extract-plugin
export var locationCard = "_pm-0";